export const optionsPerfil = [
  {
    nome: 'Porta-aberta',
    descricao: null,
    grupo: 'atendimento_emergencia',
    valor: 'atendimento_emergencia_porta_aberta',
    nomeHtml: 'Porta-aberta',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Referenciada',
    descricao: null,
    grupo: 'atendimento_emergencia',
    valor: 'atendimento_emergencia_referenciada',
    nomeHtml: 'Referenciada',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Accrediation Canada (ACI)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_aci',
    nomeHtml: 'Accrediation Canada (ACI)',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Acreditação Nacional Integrada para Organizações de Saúde (Niaho)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_niaho',
    nomeHtml:
      'Acreditação Nacional Integrada para Organizações de Saúde (Niaho)',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Healthcare Information and Management Systems Society (HIMSS)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_himss',
    nomeHtml:
      '<i>Healthcare Information and Management Systems Society (HIMSS)</i>',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'ISO 9000',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_iso_9000',
    nomeHtml: 'ISO 9000',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Joint Commission International (JCI)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_jci',
    nomeHtml: '<i>Joint Commission International (JCI)</i>',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Occupational Health and Safety Assessment Series (OHSAS) 18001',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_ohsas',
    nomeHtml:
      '<i>Occupational Health and Safety Assessment Series (OHSAS) 18001</i>',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Organização Nacional de Acreditação (ONA I)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_ona1',
    nomeHtml: 'Organização Nacional de Acreditação (ONA I)',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Organização Nacional de Acreditação (ONA II)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_ona2',
    nomeHtml: 'Organização Nacional de Acreditação (ONA II)',
    ativo: true,
    posicao: 8,
  },
  {
    nome: 'Organização Nacional de Acreditação (ONA III)',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_ona3',
    nomeHtml: 'Organização Nacional de Acreditação (ONA III)',
    ativo: true,
    posicao: 9,
  },
  {
    nome: 'Planetree',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_planetree',
    nomeHtml: 'Planetree',
    ativo: true,
    posicao: 10,
  },
  {
    nome: 'QMentum International',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_qmentum',
    nomeHtml: '<i>QMentum International</i>',
    ativo: true,
    posicao: 11,
  },
  {
    nome: 'Qualiss',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_qualiss',
    nomeHtml: '<i>Qualiss</i>',
    ativo: true,
    posicao: 12,
  },
  {
    nome: 'Selo de Qualidade do Sistema Cofen',
    descricao: null,
    grupo: 'certificacao_programa',
    valor: 'certificacao_programa_cofen',
    nomeHtml: 'Selo de Qualidade do Sistema Cofen',
    ativo: true,
    posicao: 13,
  },
  {
    nome: 'Centro de diagnóstico por imagem',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_por_imagem',
    nomeHtml: 'Centro de diagnóstico por imagem',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Fisioterapia/Reabilitação',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_fisioterapia_reabilitacao',
    nomeHtml: 'Fisioterapia/Reabilitação',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Fonoaudiologia',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_fonoaudiologia',
    nomeHtml: 'Fonoaudiologia',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Hemodiálise',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_homedialise',
    nomeHtml: 'Hemodiálise',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Hemodinâmica',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_hemodinamica',
    nomeHtml: 'Hemodinâmica',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Laboratório de análises clínicas / Patologia clínica',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_lab_analise_patoligia',
    nomeHtml: 'Laboratório de análises clínicas / patologia clínica',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Laboratório de citopatologia / Anatomia patológica',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_lab_anatomia_patologica',
    nomeHtml: 'Laboratório de citopatologia/anatomia patológica',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Laboratório de medicina nuclear',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_lab_medicina_nuclear',
    nomeHtml: 'Laboratório de medicina nuclear',
    ativo: true,
    posicao: 8,
  },
  {
    nome: 'Nutrição',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_nutricao',
    nomeHtml: 'Nutrição',
    ativo: true,
    posicao: 9,
  },
  {
    nome: 'Psicologia ou Atenção psicossocial',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_psicologia_atencao_psicossocial',
    nomeHtml: 'Psicologia ou Atenção psicossocial',
    ativo: true,
    posicao: 10,
  },
  {
    nome: 'Quimioterapia',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_quimioterapia',
    nomeHtml: 'Quimioterapia',
    ativo: true,
    posicao: 11,
  },
  {
    nome: 'Radioterapia',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_radioterapia',
    nomeHtml: 'Radioterapia',
    ativo: true,
    posicao: 12,
  },
  {
    nome: 'Serviço Social',
    descricao: null,
    grupo: 'diagnotico_terapeutico',
    valor: 'diagnotico_terapeutico_servico_social',
    nomeHtml: 'Serviço Social',
    ativo: true,
    posicao: 13,
  },
  {
    nome: 'Cardiologia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_cardiologia',
    nomeHtml: 'Cardiologia',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Cirurgia Geral',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_cirurgia_geral',
    nomeHtml: 'Cirurgia Geral',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Clínica Médica',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_clinica_medica',
    nomeHtml: 'Clínica Médica',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Ginecologia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_ginecologia',
    nomeHtml: 'Ginecologia',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Neurologia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_neurologia',
    nomeHtml: 'Neurologia',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Obstetrícia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_obstetricia',
    nomeHtml: 'Obstetrícia',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Oftalmologia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_oftamologica',
    nomeHtml: 'Oftalmologia',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Oncologia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_oncologica',
    nomeHtml: 'Oncologia',
    ativo: true,
    posicao: 8,
  },
  {
    nome: 'Pediatria',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_pediatrica',
    nomeHtml: 'Pediatria',
    ativo: true,
    posicao: 9,
  },
  {
    nome: 'Psiquiatria',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_psiquiatrica',
    nomeHtml: 'Psiquiatria',
    ativo: true,
    posicao: 10,
  },
  {
    nome: 'Traumatologia-Ortopedia',
    descricao: null,
    grupo: 'emergencia_especializada',
    valor: 'emergencia_especializada_traumatologia_ortopedia',
    nomeHtml: 'Traumatologia-Ortopedia',
    ativo: true,
    posicao: 11,
  },
  {
    nome: 'Ministério da Saúde - SUS',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_sus',
    nomeHtml: 'Ministério da Saúde - SUS',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Modelo Australiano - Australian Triage Scale (ATS)',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_ats',
    nomeHtml: 'Modelo Australiano - <i>Australian Triage Scale (ATS)</i>',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Modelo Canadense - Canadian Triage and Acuity Scale (CTAS)',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_ctas',
    nomeHtml:
      'Modelo Canadense - <i>Canadian Triage and Acuity Scale (CTAS)</i>',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Modelo de Manchester - Manchester Triage System (MTS)',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_mts',
    nomeHtml: 'Modelo de Manchester - <i>Manchester Triage System (MTS)</i>',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Modelo Americano - Emergency Severity Index (ESI)',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_esi',
    nomeHtml: 'Modelo Americano -<i> Emergency Severity Index (ESI)</i>',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Fast Track/Smart Track',
    descricao: null,
    grupo: 'estratificacao_risco',
    valor: 'estratificacao_risco_smart_track',
    nomeHtml: 'Fast Track/Smart Track',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Neonatal',
    descricao: null,
    grupo: 'perfil_etario',
    valor: 'perfil_etario_neonatal',
    nomeHtml: 'Neonatal',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Pediátrico',
    descricao: null,
    grupo: 'perfil_etario',
    valor: 'perfil_etario_pediatrico',
    nomeHtml: 'Pediátrico',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Adulto',
    descricao: null,
    grupo: 'perfil_etario',
    valor: 'perfil_etario_adulto',
    nomeHtml: 'Adulto',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Idosos',
    descricao: null,
    grupo: 'perfil_etario',
    valor: 'perfil_etario_idosos',
    nomeHtml: 'Idosos',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Clínica',
    descricao: null,
    grupo: 'perfil_internacao_hospitalar',
    valor: 'perfil_internacao_hospitalar_clinica',
    nomeHtml: 'Clínica',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Cirúrgica',
    descricao: null,
    grupo: 'perfil_internacao_hospitalar',
    valor: 'perfil_internacao_hospitalar_cirurgica',
    nomeHtml: 'Cirúrgica',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Psiquiátrica',
    descricao: null,
    grupo: 'perfil_internacao_hospitalar',
    valor: 'perfil_internacao_hospitalar_psiquiatrica',
    nomeHtml: 'Psiquiátrica',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Pediátrica',
    descricao: null,
    grupo: 'perfil_internacao_hospitalar',
    valor: 'perfil_internacao_hospitalar_pediatrica',
    nomeHtml: 'Pediátrica',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Obstétrica',
    descricao: null,
    grupo: 'perfil_internacao_hospitalar',
    valor: 'perfil_internacao_hospitalar_obstetrica',
    nomeHtml: 'Obstétrica',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Acidente Vascular Cerebral',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_avc',
    nomeHtml: 'Acidente Vascular Cerebral',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Câncer de Mama',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_cancer_mama',
    nomeHtml: 'Câncer de Mama',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Câncer de Próstata',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_cancer_prostata',
    nomeHtml: 'Câncer de Próstata',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Cirurgia de Quadril',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_cirurgia_quadril',
    nomeHtml: 'Cirurgia de Quadril',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Cirurgia segura',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_cirurgia_segura',
    nomeHtml: 'Cirurgia segura',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Cuidados paliativos',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_cuidados_paliativos',
    nomeHtml: 'Cuidados paliativos',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Instalação de Cateter Venoso Central',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_instalacao_cateter_v_central',
    nomeHtml: 'Instalação de Cateter Venoso Central',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Instalação de Cateter Vesical de Demora',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_instalacao_cateter_v_demora',
    nomeHtml: 'Instalação de Cateter Vesical de Demora',
    ativo: true,
    posicao: 8,
  },
  {
    nome: 'Notificação de Eventos Adversos',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_notificacao_eventos_adversos',
    nomeHtml: 'Notificação de Eventos Adversos',
    ativo: true,
    posicao: 9,
  },
  {
    nome: 'Obstetrícia',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_obstetricia',
    nomeHtml: 'Obstetrícia',
    ativo: true,
    posicao: 10,
  },
  {
    nome: 'Parada cardiorrespiratória',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_parada_cardiorrespiratoria',
    nomeHtml: 'Parada cardiorrespiratória',
    ativo: true,
    posicao: 11,
  },
  {
    nome: 'Prevenção de quedas',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_prevencao_quedas',
    nomeHtml: 'Prevenção de quedas',
    ativo: true,
    posicao: 12,
  },
  {
    nome: 'Profilaxia de Tromboembolismo Venoso',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_profiliaxia',
    nomeHtml: 'Profilaxia de Tromboembolismo Venoso',
    ativo: true,
    posicao: 13,
  },
  {
    nome: 'Sepse',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_sepse',
    nomeHtml: 'Sepse',
    ativo: true,
    posicao: 14,
  },
  {
    nome: 'Síndrome Coronariana Aguda',
    descricao: null,
    grupo: 'protocolos_clinicos_institucionais',
    valor: 'protocolos_clinicos_institucionais_coronariana',
    nomeHtml: 'Síndrome Coronariana Aguda',
    ativo: true,
    posicao: 15,
  },
  {
    nome: 'CQH',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_cqh',
    nomeHtml: 'CQH',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'ICHOM',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_ichom',
    nomeHtml: 'ICHOM',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Núcleo de Segurança do Paciente - ANVISA',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_nsp_anvisa',
    nomeHtml: 'Núcleo de Segurança do Paciente - ANVISA',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Parto Adequado',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_parto_adequado',
    nomeHtml: 'Parto Adequado',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Programa Brasileiro de Segurança do Paciente (PBSP)',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_pbsp',
    nomeHtml: 'Programa Brasileiro de Segurança do Paciente (PBSP)',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Proqualis',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_proqualis',
    nomeHtml: 'Proqualis',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'SINHA',
    descricao: null,
    grupo: 'sistema_informatizado_avaliacao',
    valor: 'sistema_informatizado_avaliacao_sinha',
    nomeHtml: 'SINHA',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Módulo de prescrição',
    descricao: null,
    grupo: 'sistema_informatizado_protuario',
    valor: 'sistema_informatizado_protuario_modulo_de_prescricao',
    nomeHtml: 'Módulo de prescrição',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Módulo de evolução',
    descricao: null,
    grupo: 'sistema_informatizado_protuario',
    valor: 'sistema_informatizado_protuario_modulo_de_evolucao',
    nomeHtml: 'Módulo de evolução',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Módulo de Serviços de Apoio ao Diagnóstico Terapêutico (SADT)',
    descricao: null,
    grupo: 'sistema_informatizado_protuario',
    valor: 'sistema_informatizado_protuario_servico_de_apoio',
    nomeHtml: 'Módulo de Serviços de Apoio ao Diagnóstico Terapêutico (SADT)',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Checagem de prescrição',
    descricao: null,
    grupo: 'sistema_informatizado_protuario',
    valor: 'sistema_informatizado_protuario_checagem_prescicao',
    nomeHtml: 'Checagem de prescrição',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Traumato-ortopedia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_traumato_ortopedia',
    nomeHtml: 'Traumato-ortopedia',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Materno-infantil',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_materno_infantil',
    nomeHtml: 'Materno-infantil',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Ginecologia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_ginecologia',
    nomeHtml: 'Ginecologia',
    ativo: true,
    posicao: 3,
  },
  {
    nome: 'Pediatria',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_pediatria',
    nomeHtml: 'Pediatria',
    ativo: true,
    posicao: 4,
  },
  {
    nome: 'Cardiologia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_cardiologia',
    nomeHtml: 'Cardiologia',
    ativo: true,
    posicao: 5,
  },
  {
    nome: 'Neurologia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_neurologia',
    nomeHtml: 'Neurologia',
    ativo: true,
    posicao: 6,
  },
  {
    nome: 'Oncologia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_oncologia',
    nomeHtml: 'Oncologia',
    ativo: true,
    posicao: 7,
  },
  {
    nome: 'Oftalmologia',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_oftalmologia',
    nomeHtml: 'Oftalmologia',
    ativo: true,
    posicao: 8,
  },
  {
    nome: 'Psiquiatria',
    descricao: null,
    grupo: 'tipo_estabelecimento',
    valor: 'tipo_estabeleciomento_psiquiatria',
    nomeHtml: 'Psiquiatria',
    ativo: true,
    posicao: 9,
  },
  {
    nome: 'Coronariana',
    descricao: null,
    grupo: 'uti_especializada',
    valor: 'uti_especializada_coronariana',
    nomeHtml: 'Coronariana',
    ativo: true,
    posicao: 1,
  },
  {
    nome: 'Neurológica',
    descricao: null,
    grupo: 'uti_especializada',
    valor: 'uti_especializada_neurologica',
    nomeHtml: 'Neurológica',
    ativo: true,
    posicao: 2,
  },
  {
    nome: 'Cirúrgica',
    descricao: null,
    grupo: 'uti_especializada',
    valor: 'uti_especializada_cirurgica',
    nomeHtml: 'Cirúrgica',
    ativo: true,
    posicao: 3,
  },
];
